<template>
  <section class="media-center">
    <div class="head">
      <h1 class="title">媒体中心</h1>
    </div>
    <div class="tab" ref="tab">
      <el-tabs v-model="active" @tab-click="handleClick" stretch>
        <el-tab-pane label="新闻稿" name="first"></el-tab-pane>
        <el-tab-pane label="新闻报道" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <news id="press"></news>
    <news Ltype="新闻报道" id="news"></news>
  </section>
</template>

<script>
import news from './component/news.vue'

export default {
  name: 'mediaCenter',
  components: {
    news
  },
  data() {
    return {
      active: '',
      pressTop: '',
      newsTop: ''
    }
  },
  methods: {
    handleScroll() {
      // 页面滑动的距离
      let scrollTop = document.documentElement.scrollTop
      // 当页面滑动的距离大于300px时元素显示，否则不显示
      if (scrollTop >= 184) {
        this.$refs.tab.style.cssText = 'position: fixed; top: 65px;'
      } else {
        this.$refs.tab.style.cssText = ''
      }
      let press = document.getElementById('press').getBoundingClientRect()
      let news = document.getElementById('news').getBoundingClientRect()
      if (press.top <= 100 && scrollTop <= press.height + this.pressTop - 150) {
        this.active = 'first'
      } else if (
        news.top <= 100 &&
        scrollTop <= news.height + this.newsTop - 150
      ) {
        this.active = 'second'
      } else {
        this.active = ''
      }
      // console.log(scrollTop, news, press, this.pressTop, this.newsTop)
    },
    handleClick(e) {
      if (e.index < 1) {
        window.scrollTo(0, this.pressTop - 59)
      } else {
        window.scrollTo(0, this.newsTop - 59)
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.pressTop = document.getElementById('press').offsetTop
    this.newsTop = document.getElementById('news').offsetTop
  },
  // 组件销毁前
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.media-center {
  background-color: #fff;
  div,
  p,
  h1 {
    font-family: 'Arimo', Sans-serif;
    color: #2a2c2f;
  }
  .head {
    width: 100%;
    .title {
      font-family: 'Poppins', Sans-serif;
      font-size: 48px;
      line-height: 184px;
      text-align: center;
    }
  }
  .tab {
    background-color: #fff;
    z-index: 100;
    padding-top: 20px;
    box-shadow: 0px 15px 20px 0px rgba(0, 0, 0, 0.05);
    height: 79px;
    margin-top: 0px;
    margin-bottom: 0px;
    position: absolute;
    width: 100%;
    ::v-deep .el-tabs {
      width: 400px;
      margin: 0 auto;
      .is-top {
        text-align: center;
        color: #bfc0c1;
        font-weight: 600;
        font-family: 'Poppins', Sans-serif;
        font-size: 20px;
        font-weight: 600;
      }
      .el-tabs__active-bar {
        background-color: #2f5ad9;
        width: 200px !important;
        height: 6px !important;
        border-radius: 3px;
      }
      .is-active {
        color: #2a2c2f;
      }
    }
  }
}
</style>
